(function () {
  if (customElements.get('ce-drop-down') !== undefined) {
    return;
  }

  class DropDown extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        container: '[data-drop-down-container]',
        buttonToggle: '[data-drop-down-button-toggle]',
        panel: '[data-drop-down-panel]',
      };

      this.elements = null;
      this.hasLoaded = false;

      this.handleStickyScrollHeaderScrollDirection = this.handleStickyScrollHeaderScrollDirection.bind(this);
      this.handleFocusOut = this.handleFocusOut.bind(this);
      this.handleClickButtonToggle = this.handleClickButtonToggle.bind(this);
      this.handleMouseEnterPanel = this.handleMouseEnterPanel.bind(this);
      this.handleMouseLeavePanel = this.handleMouseLeavePanel.bind(this);
      this.handleMouseEnterButtonToggle = this.handleMouseEnterButtonToggle.bind(this);
      this.handleMouseLeaveDropDown = this.handleMouseLeaveDropDown.bind(this);
    }

    get isOpen() {
      return this.getAttribute('is-open') === 'true';
    }

    set isOpen(value) {
      this.setAttribute('is-open', value);
    }

    static get observedAttributes() {
      return ['is-open'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'is-open':
          if (newValue !== null) {
            if (newValue === 'true') {
              this.elements.container.setAttribute('open', '');
              this.playAnimationOpen();
            } else {
              if (!this.hasLoaded) {
                break;
              }
              this.playAnimationClose();
            }
          }
          break;
      }
    }

    parsedCallback() {
      this.elements = {
        container: this.querySelector(this.selectors.container),
        buttonToggle: this.querySelector(this.selectors.buttonToggle),
        panel: this.querySelector(this.selectors.panel),
      };

      document.addEventListener('ce-sticky-scroll-header:scroll-direction', this.handleStickyScrollHeaderScrollDirection);
      this.addEventListener('focusout', this.handleFocusOut);
      this.elements.buttonToggle.addEventListener('click', this.handleClickButtonToggle);
      this.elements.buttonToggle.addEventListener('mouseenter', this.handleMouseEnterButtonToggle);
      this.addEventListener('mouseleave', this.handleMouseLeaveDropDown);
      this.elements.panel.addEventListener('mouseenter', this.handleMouseEnterPanel);
      this.elements.panel.addEventListener('mouseleave', this.handleMouseLeavePanel);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('ce-sticky-scroll-header:scroll-direction', this.handleStickyScrollHeaderScrollDirection);
      this.removeEventListener('focusout', this.handleFocusOut);
      this.elements.buttonToggle.removeEventListener('click', this.handleClickButtonToggle);
      this.elements.buttonToggle.removeEventListener('mouseenter', this.handleMouseEnterButtonToggle);
      this.removeEventListener('mouseleave', this.handleMouseLeaveDropDown);
      this.elements.panel.removeEventListener('mouseenter', this.handleMouseEnterPanel);
      this.elements.panel.removeEventListener('mouseleave', this.handleMouseLeavePanel);
    }

    playAnimationOpen() {
      const keyframes = [
        { opacity: 0, transform: 'translateY(-16px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ];

      const options = {
        duration: Themu.prefersReducedMotion ? 0 : 150,
        easing: Themu.animation.easeIn,
        fill: 'both',
      };

      const animation = this.elements.panel.animate(keyframes, options);
      animation.addEventListener('finish', () => {
        animation.commitStyles();
        animation.cancel();
        this.elements.buttonToggle.setAttribute('aria-expanded', 'true');
        this.elements.buttonToggle.setAttribute('aria-pressed', 'true');
        this.hasLoaded = true;
      });
    }

    playAnimationClose() {
      const keyframes = [
        { opacity: 1, transform: 'translateY(0)' },
        { opacity: 0, transform: 'translateY(-16px)' },
      ];

      const options = {
        duration: Themu.prefersReducedMotion ? 0 : 150,
        easing: Themu.animation.easeOut,
        fill: 'both',
      };

      const animation = this.elements.panel.animate(keyframes, options);
      animation.addEventListener('finish', () => {
        animation.commitStyles();
        animation.cancel();
        this.elements.buttonToggle.setAttribute('aria-expanded', 'false');
        this.elements.buttonToggle.setAttribute('aria-pressed', 'false');
        this.elements.container.removeAttribute('open');
      });
    }

    handleStickyScrollHeaderScrollDirection(event) {
      const scrollDirection = event.detail;
      if (scrollDirection === 'down') {
        this.isOpen = false;
      }
    }

    handleFocusOut(event) {
      if (this.hasMouseFocus) {
        return;
      }
      if (event.relatedTarget !== null && event.relatedTarget.closest(`#${this.id}`) !== null) {
        return;
      }
      this.isOpen = false;
    }

    handleClickButtonToggle(event) {
      event.preventDefault();
      this.isOpen = !this.isOpen;
    }

    handleMouseEnterButtonToggle() {
      this.isOpen = true;
    }

    handleMouseLeaveDropDown() {
      this.isOpen = false;
    }

    handleMouseEnterPanel() {
      this.hasMouseFocus = true;
    }

    handleMouseLeavePanel() {
      this.hasMouseFocus = false;
      if (document.activeElement.closest(`#${this.id}`) !== null) {
        return;
      }
      this.isOpen = false;
    }
  }

  customElements.define('ce-drop-down', DropDown);
})();
